import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import CreateBusiness from './CreateBusiness'
import ListBusinesses from './ListBusinesses'
import EditBusiness from './EditBusiness'

const Businesses = ({ match }) => (
  <div>
    <Route
      exact
      path={match.url}
      render={props => <ListBusinesses {...props} />}
    />
    <Switch>
      <Route exact path={`${match.url}/add`} component={CreateBusiness} />
      <Route
        path={`${match.url}/:id`}
        render={props => <EditBusiness {...props} />}
      />
    </Switch>
  </div>
)

ListBusinesses.propTypes = {
  match: PropTypes.object.isRequired
}

export default Businesses
